import apiClient, { safeJson } from '@/api/client';
import {
    TodayCheckinResponse,
    CheckinLogListParams,
    CheckinLogListResponse,
} from './types';

/**
 * @method get
 * @brief 오늘 출석 현황
 */
export const getTodayCheckins = async ({ centerId }: { centerId: string }) => {
    const res = await apiClient.get(`v1/centers/${centerId}/checkin-logs/today`);
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as TodayCheckinResponse | null,
    };
};

/**
 * @method get
 * @brief 출석 이력 조회
 */
export const getCheckinLogs = async ({
    centerId,
    startDate,
    endDate,
    search,
    page,
    limit,
}: CheckinLogListParams) => {
    const searchParams: Record<string, string> = {};
    if (startDate) searchParams.startDate = startDate;
    if (endDate) searchParams.endDate = endDate;
    if (search) searchParams.search = search;
    if (page !== undefined) searchParams.page = String(page);
    if (limit !== undefined) searchParams.limit = String(limit);

    const res = await apiClient.get(`v1/centers/${centerId}/checkin-logs`, { searchParams });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CheckinLogListResponse | null,
    };
};

/**
 * @method post
 * @brief 수동 체크아웃
 */
export const manualCheckout = async ({
    centerId,
    logId,
}: {
    centerId: string;
    logId: string;
}) => {
    const res = await apiClient.post(`v1/centers/${centerId}/checkin-logs/${logId}/checkout`);
    return safeJson(res);
};

/**
 * @method post
 * @brief 자동 체크아웃 (90분 경과 건 일괄)
 */
export const autoCheckout = async ({ centerId }: { centerId: string }) => {
    const res = await apiClient.post(`v1/centers/${centerId}/checkin-logs/auto-checkout`);
    return safeJson(res);
};

/**
 * @method get
 * @brief 회원별 출석 이력
 */
export const getMemberCheckinHistory = async ({
    centerId,
    memberId,
    page,
    limit,
}: {
    centerId: string;
    memberId: string;
    page?: number;
    limit?: number;
}) => {
    const searchParams: Record<string, string> = {};
    if (page !== undefined) searchParams.page = String(page);
    if (limit !== undefined) searchParams.limit = String(limit);

    const res = await apiClient.get(`v1/centers/${centerId}/checkin-logs/member/${memberId}`, { searchParams });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CheckinLogListResponse | null,
    };
};
